.recentSearchesList {
    width: 100%;
    padding-top: var(--mantine-spacing-xl);
}

.recentSearchLink {
    display: block;
    padding: var(--mantine-spacing-sm) 0;
    padding-left: 0;
    border-bottom: 1px solid var(--mantine-color-gray-3);
    text-decoration: none !important;
    color: inherit;
    transition: padding-left var(--transition-duration-snappy) ease-out;

    &:hover {
        text-decoration: none !important;
        padding-left: var(--mantine-spacing-sm);
    }

    &:last-child {
        border-bottom: none;
    }

    /* Override Mantine Anchor default underline styles */
    &,
    & * {
        text-decoration: none !important;
    }
}

.recentSearchChevron {
    opacity: 0;
    transform: translateX(-8px);
    transition:
        opacity var(--transition-duration-snappy) var(--transition-ease-snappy),
        transform var(--transition-duration-fast) var(--transition-ease-snappy);
    flex-shrink: 0;
}

.recentSearchLink:hover .recentSearchChevron {
    opacity: 1;
    transform: translateX(0);
}

.recentSearchItem {
    width: 100%;
    justify-content: flex-start;
}
